const { DefaultAzureCredential, ClientSecretCredential } = require('@azure/identity');
const { StorageSharedKeyCredential: queueSharedCredential } = require('@azure/storage-queue');
const { AzureNamedKeyCredential: tableSharedCredential } = require('@azure/data-tables');
const {StorageSharedKeyCredential: blobSharedCredential} = require('@azure/storage-blob');
const {AderantAzureStorageError} = require('../utils/errors');
/**
 * Gets the credential for the given use case. If you are using an azure Identity,
 * this function will return the DefaultAzureCredential, if you are using a client
 * id, secret and tenant Id then you will receive the ClientSecretCredential.
 * @param {object} clientOptions the options for setting up the client
 * @param {string} type 'table', 'blob' or 'queue'. Defines the type of credential to return.
 * @returns Credential
 * @throws error: returns an error if you have misconfigured your application with
 * detailed messages.
 */
const getCredential = (clientOptions, type) => {
    if (clientOptions.useIdentity) {
        return new DefaultAzureCredential();
    }
    if (clientOptions.accountKey && !clientOptions.useIdentity) {
        return determineStorageSharedKeyCredentialType(clientOptions, type);
    }
    if (clientOptions.clientId && clientOptions.clientSecret && clientOptions.tenantId) {
        if (clientOptions.clientId || clientOptions.clientSecret || clientOptions.tenantId) {
            throw new AderantAzureStorageError(`The clientId, client_secret and service_tenant_id are required when using a client secret credential.`);
        }
        return new ClientSecretCredential(
            config.tenantId,
            config.clientId,
            config.clientSecret
        );
    }
    throw new AderantAzureStorageError(`The given configuration is invalid. You must either provide an accountKey or a client_id, client_secret and tenant_id or use an identity for this service. Please review documentation.`);
}

/**
 * Why? Why did you make this? Well, if you're trying to get a credential between different
 * azure storage options you need to use a different credential for different provider types.
 * To support this, you need to know which service they are trying to access. Well, the only
 * real way to do this is to have the caller tell you in some way. 
 * 
 * Thanks Microsoft.
 * @param {object} clientOptions 
 * @param {string} type 
 * @returns 
 */
const determineStorageSharedKeyCredentialType = (clientOptions, type) => {
    switch (type.toLowerCase()) {
        case 'queue':
            return new queueSharedCredential(clientOptions.accountName, clientOptions.accountKey);
        case 'blob':
            return new blobSharedCredential(clientOptions.accountName, clientOptions.accountKey);
        case 'table':
            return new tableSharedCredential(clientOptions.accountName, clientOptions.accountKey);
        default:
            throw new AderantAzureStorageError(`You must provide a type of table, blob or queue in the type property`);
    }
}

module.exports = { getCredential };